<template>
    <div>
        <ui-modal ref="modal" :title="title" dismiss-on="close-button esc" @hide="hide" size="larger">
        <lead-pane
            ref="leadPane"
            :defaults="leadDefaults"
            @saving="isSaving = true" 
            @saved="finishSave"
            @error="isSaving = false"
        />

        <p v-if="lead && lead.created_by" style="margin-bottom: 0; color: #999;">
            Created by {{ lead.created_by.name }}, {{ lead.created_at | formatDate }}.
        </p>

        <div slot="footer" class="container-fluid no-left-padding no-right-padding">
            <div class="row align-items-center">
                <div class="col text-left">
                    <ui-icon-button 
                        ref="dropdownButton"
                        has-dropdown 
                        icon="more_vert"
                        :disabled="!lead || isSaving"
                    >
                        <ui-menu
                            contain-focus
                            has-icons
                            slot="dropdown"
                            :options="menuOptions"
                            @select="menuItemSelected"
                            @close="$refs.dropdownButton.closeDropdown()"
                        ></ui-menu>
                    </ui-icon-button>
                </div>
                <div class="col text-right">
                    <div style="display: inline-block;" class="ml-4">
                        <ui-button 
                            @click="$refs.leadPane.save()"
                            :loading="isSaving" 
                            color="primary"
                        >Save</ui-button>
                    </div>
                </div>
            </div>
        </div>
    </ui-modal>

        <activity-modal
            ref="activityModal"
            @saved="$emit('saved')"
        />
    </div>
</template>

<script>
    import LeadPane from '../forms/LeadPane'
    import { LeadResource } from '../../classes/Api/Lead'
    import Filters from '../../filters'
    import ActivityModal from "../ActivityModal";
    import {ActivityResource} from "../../classes/Api/Activity";
    import ActivityHelpers from "./ActivityHelpers";

    const menuOptions = [
        {
            label: 'Delete',
            icon: 'delete'
        },
    ];

    export default {
        filters: Filters,
        mixins: [ActivityHelpers],
        components: {
            ActivityModal,
            LeadPane
        },
        props: {
            defaults: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {
                lead: null,
                isSaving: false,
                isDone: false,
            }
        },
        computed: {
            title() {
                return this.lead && this.lead.id ? 'Update Lead' : 'New Lead'
            },
            menuOptions() {
                return menuOptions
            },
            leadDefaults() {
                return Object.assign({
                    owner: window.marque.ui.user,
                    owner_id: window.marque.ui.user.id,
                    location: window.marque.ui.location,
                    location_id: window.marque.ui.location.id,
                }, this.defaults)
            }
        },
        methods: {
            open(lead = null) {
                if (lead) {
                    this.lead = lead
                    this.$refs.leadPane.setLead(lead)
                } else {
                    this.$refs.leadPane.reset()
                }

                this.$refs.modal.open();
            },
            hide() {
                this.reset()
                this.$emit('hide')
            },
            reset() {
                this.$refs.leadPane.reset()
                this.lead = null
                this.isSaving = false
                this.isDone = false
            },
            close() {
                this.$refs.modal.close();
                this.reset()
                this.$emit('closing')
            },
            finishSave(lead) {
                let promise;

                if (this.isDone && !lead.completed_at) {
                    promise = ActivityResource.complete(lead.id)
                } else if (!this.isDone && lead.completed_at) {
                    promise = ActivityResource.uncomplete(lead.id);
                }

                Promise.all([promise]).then(() => {
                    this.isSaving = false; 
                    this.close()

                    this.$refs.activityModal.open(
                        this.newActivityForLead(lead)
                    )

                    this.$emit('saved')
                }).catch(e => {
                    handleApiError(e)
                    this.isSaving = false
                })
            },
            menuItemSelected(item) {
                if (item.icon === 'delete' && confirm('Are you sure you want to delete this lead?')) {
                    this.isSaving = true

                    ActivityResource.destroy(this.lead.id).then(response => {
                        this.isSaving = false
                        this.close()
                    }).catch(e => {
                        handleApiError(e)
                        this.isSaving = false
                    })
                }
            }
        }
    }
</script>